var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookPostShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB-share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB-share",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0002379,17.8741567 C2.2118296,13.890249 3.07049967,11.1687045 4.57624811,9.7095232 C6.09779847,8.23502871 8.05625727,7.47461771 10.4516245,7.42829018 L10.4516245,3.32029737 C10.4516245,3.14340202 10.5950265,3 10.7719219,3 L10.7719219,3 C10.976658,3 11.1726536,3.08297419 11.3151566,3.22997683 L17.5169225,9.62756975 C17.9013306,10.0241159 17.8914907,10.6572044 17.4949446,11.0416125 C17.4928309,11.0436615 17.4907082,11.0457011 17.4885766,11.0477313 L11.1160032,17.1170038 C11.0459765,17.1836975 10.9666461,17.239881 10.8804895,17.2837995 L10.7310161,17.3599939 C10.6364778,17.408185 10.5207726,17.3706131 10.4725815,17.2760748 C10.458806,17.2490509 10.4516245,17.2191494 10.4516245,17.188817 L10.4516245,12.8949987 C8.73620915,12.7883774 7.25982301,13.1273968 6.02246607,13.9120569 C4.78510913,14.6967169 3.52608231,16.0593646 2.24538561,18 L2.11958786,18 C2.05358739,18 2.00008345,17.9464961 2.00008345,17.8804956 C2.00008345,17.8783818 2.00013953,17.8762683 2.00025164,17.8741575 Z",
    id: "Path-6",
    stroke: "#606770"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    strokeOpacity: 0,
    stroke: "#979797",
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPostShare);
export default __webpack_public_path__ + "static/media/facebook-post-share.7a81119a12335c310728b7634bd3302e.svg";
export { ForwardRef as ReactComponent };